import { render, staticRenderFns } from "./OptionRender.vue?vue&type=template&id=3a881711&"
import script from "./OptionRender.vue?vue&type=script&lang=ts&"
export * from "./OptionRender.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports